<template>
	<div>
		<div style="text-align: left; padding-bottom: 10px;">
			<el-row :gutter="2">
					<el-col :span="6">
						
						<el-button type="primary" @click="employUpdate">发布信息</el-button>
						
					</el-col>
					<el-col :span="6">
						
							<el-input v-model="companyName" class="" placeholder="公司名称"></el-input>
						
					</el-col>
					<el-col :span="12">
						
						<el-button type="primary" @click="searchFreeMarket">查询</el-button>
						
					</el-col>
				</el-row>
			
		</div>
		<el-table :data="tableData" style="width: 100%" border stripe>
			<el-table-column prop="id" label="编号" width="50"></el-table-column>
      		<el-table-column prop="title" label="信息内容" width="180"></el-table-column>
      		<el-table-column prop="type" label="信息类型" width="180">
      			<template slot-scope="scope">
      				<el-tag v-if="scope.row.type==1" type="danger">招聘</el-tag>
      				<el-tag v-if="scope.row.type==2" type="success">租赁</el-tag>
      			</template>
      		</el-table-column>
      		<el-table-column prop="createTime" label="创建时间" width="150"></el-table-column>
      		<el-table-column prop="state" label="状态" width="180">
	      		<template slot-scope="scope">
      				<el-tag v-if="scope.row.state==0" type="danger">无效</el-tag>
      				<el-tag v-if="scope.row.state==1" type="success">有效</el-tag>
      			</template>
      		</el-table-column>	
      		<el-table-column label="操作" width="250">
      			<template scope="scope">
					<el-button size="small" v-if="scope.row.state==0" @click="visibleEmploy(scope.$index, scope.row)">置为有效</el-button>
					<el-button size="small" v-if="scope.row.state==1" @click="visibleEmploy(scope.$index, scope.row)">置为无效</el-button>
					<el-button size="small" @click="employUpdate(scope.$index, scope.row)">修改</el-button>
				</template>
      		</el-table-column>
      	</el-table>
      	<el-pagination background ayout="prev, next" @current-change="handlerCurrentPage"  :page-size="pageSize" :total="total">
		</el-pagination>


		
	</div>

	
</template>
<script >
	import {getEmployList,visibleEmploy} from "@/api/api"
	export default {
		data(){
		 	return {
		 		tableData:[],
		 		pageSize:15,
		 		total:0,
		 		pageCount:0,
		 		companyName:''
		 	}
		},
		created:function() {
			var _this = this;
			let params = {pageNum:0,pageSize:this.pageSize};
			getEmployList(params).then(res =>{
				this.tableData = res.data.data.list;
				this.total = res.data.data.total;
				this.pageCount=res.data.data.pages;
			});
			
		},
		methods:{
			searchFreeMarket(){
				this.reload();
			},
			handlerCurrentPage(currentPage){
				let params = {pageNum:currentPage,pageSize:this.pageSize};
				getEmployList(params).then(res =>{
					this.tableData = res.data.data.list;
					this.total = res.data.data.total;
					this.pageCount = res.data.data.pages;
				});
			},
			employUpdate(index,row){
				var param = {};
				if(row!=null){
					param.id = row.id;
				}
				this.$router.push({name:"employUpdate",query:param});
			},
			reload(){
				console.log("reload");
				let params = {pageNum:this.currentPage,pageSize:this.pageSize,companyName:this.companyName};
				getEmployList(params).then(res =>{
					this.tableData = res.data.data.list;
					this.total = res.data.data.total;
					this.pageCount = res.data.data.pages;
					this.currentPage = res.data.data.pageNum;
				});
			},
			visibleEmploy(index,row){
				let _this = this;
				let params={id:row.id};
				if(row.state==1){
					params.state=0;
				}else{
					params.state=1;
				}
				visibleEmploy(params).then(res=>{
					if(res.data.status=='success'){
						this.$message({
					            type: 'success',
					            message: '操作成功'
					         });
						_this.reload();
					}
				});
			}
		}
	}
</script>